import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/guidelines/selectors';

export const getState = createSelector(getParent, state => state.ui.dashboard);

export const getFilters = createSelector(getState, state => state.filters);
